<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <!-- <a-col :md="6" :sm="12" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                    item.tenantName
                  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="抄表员编号">
              <a-input v-model="query.meterReadingNo" placeholder="请输入抄表员编号" allow-clear />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="12">
            <a-form-item label="名称">
              <a-input v-model="query.name" placeholder="请输入名称" allow-clear />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="手机号码">
              <a-input v-model="query.phone" placeholder="请输入手机号码" allow-clear />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="12" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
            </a-form-item>
            <a-form-item style="margin-left: 12px">
              <a-button @click="resetList">重置</a-button>
            </a-form-item>
            <a-form-item style="margin-left: 8px">
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()">新增</a-button>
            </a-form-item>
            <a-form-item style="margin-left: 8px">
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()">删除</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :columns="columns"
      :loading="dataListLoading"
      :dataSource="list"
      :pagination="pagination"
      :rowSelection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      @change="pageChange"
    >
      <span slot="img" slot-scope="text">
        <img :src="text" alt="" style="height: 100px" />
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)"> 编辑 </a>
      </span>
    </a-table>

    <!-- 新增弹框 -->
    <a-modal
      title="添加点位"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="名称">
          <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入名称!' }] }]" />
        </a-form-item>
        <a-form-item label="坐标X">
          <a-input v-decorator="['pointX', { rules: [{ required: true, message: '请输入X坐标!' }] }]" />
        </a-form-item>
        <a-form-item label="坐标Y">
          <a-input v-decorator="['pointY', { rules: [{ required: true, message: '请输入Y坐标!' }] }]" />
        </a-form-item>
        <a-form-item label="照片">
          <a-upload v-decorator="['fileUrl']" name="file" :action="uploadUrl" :headers="header" @change="handleChange">
            <a-button> <a-icon type="upload" />上传照片</a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      currentId: '',
      fileUrl: '',
      uploadUrl: `${process.env.VUE_APP_API_BASE_URL}manager/file/resources/upload`,
      addOrUpdateVisible: false,
      queryUrl: '/pipe-network/tenant_water_works_configs/page',
      queryOneUrl: '/pipe-network/tenant_water_works_configs',
      addOrUpdateUrl: '/pipe-network/tenant_water_works_configs', // 新增或更新数据url
      deleteUrl: '/pipe-network/tenant_water_works_configs', // 删除数据url
      query: {
        name: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      header: {
        Authorization: storage.get(ACCESS_TOKEN),
      },
      list: [],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '坐标X',
          dataIndex: 'pointX',
        },
        {
          title: '坐标Y',
          dataIndex: 'pointY',
        },
        {
          title: '照片',
          dataIndex: 'fileUrl',
          scopedSlots: { customRender: 'img' },
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
        },
        { title: '操作', align: 'center', dataIndex: 'action', width: 200, scopedSlots: { customRender: 'action' } },
      ],
    }
  },
  methods: {
    addOrUpdateHandle(id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            
            this.fileUrl = data.fileUrl
            this.addOrUpdateForm.setFieldsValue(data)
          })
          .catch(() => {})
      }
    },
    handleOk() {
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          if (this.fileUrl == '') {
            this.$message.error('请上传照片')
          } else {
            let data
            if (this.currentId == undefined) {
              data = {
                name: values.name,
                pointX: values.pointX,
                pointY: values.pointY,
                fileUrl: this.fileUrl,
              }
              this.$http.post(this.addOrUpdateUrl, data).then((resolve) => {
                console.log(JSON.stringify(resolve))
                this.queryList()
                this.addOrUpdateForm.resetFields()
              })
              this.addOrUpdateVisible = false
            } else {
              data = {
                id: this.currentId,
                name: values.name,
                pointX: values.pointX,
                pointY: values.pointY,
                fileUrl: this.fileUrl,
              }
              this.$http({
                url: this.addOrUpdateUrl,
                data: data,
                method: 'put',
              }).then((resolve) => {
                console.log(JSON.stringify(resolve))
                this.queryList()
                this.addOrUpdateForm.resetFields()
              })
              this.addOrUpdateVisible = false
            }
          }
        }
      })
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        this.fileUrl = info.file.response.data.url
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败`)
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>